import { z } from 'zod';

import { copy } from './copy';

/**
 * The create dialog's two fields, and they are the **complete** editable set
 * for a credential-less profile — display name and biography. Nothing is
 * deferred to a second step, and there is no role field: a role belongs to a
 * credit, which this record does not have yet.
 *
 * The slug is the one thing the dialog does not produce. Deriving a Latin slug
 * from an Arabic display name is transliteration, which the service owns and
 * the browser does not — so the created record comes back carrying its own, and
 * the row prints what the server minted.
 */
export const personSchema = z.object({
  displayName: z.string().trim().min(1, copy.dialog.name.required),
  biography: z.string().trim(),
});

export type PersonFields = z.input<typeof personSchema>;
export type PersonValues = z.output<typeof personSchema>;
